import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem(
    process.env.REACT_APP_LOCAL_TOKEN
  );

  const token_horoscope = localStorage.getItem(
    "user_token_horoscope"
  );

  if (!token && !token_horoscope) {
    return <Navigate to="/signin" replace />;
  }

  return children;
}


/* 
import { Navigate } from "react-router-dom";

function isValidToken(key) {
  const data = JSON.parse(
    localStorage.getItem(key)
  );

  if (!data) {
    return false;
  }

  if (Date.now() > data.expiresAt) {
    localStorage.removeItem(key);
    return false;
  }

  return true;
}

export default function ProtectedRoute({
  children,
}) {
  const isAuth =
    isValidToken(
      process.env.REACT_APP_LOCAL_TOKEN
    ) ||
    isValidToken(
      process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE
    );

  return isAuth ? (
    children
  ) : (
    <Navigate to="/signin" replace />
  );
} */

/* import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem(
    process.env.REACT_APP_LOCAL_TOKEN
  );

  const token_horoscope = localStorage.getItem(
    process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE
  );

  if (!token && !token_horoscope) {
    return <Navigate to="/signin" replace />;
  }

  return children;
} */